import React from "react";

interface SimpleCheckboxProps {
	itemKey: string | number;
	value?: string;
	checked?: boolean;
	onToggle: (itemKey, value: string) => void;
	inputId: string;
	disabled?: boolean;
}

export default function SimpleCheckbox({
	checked,
	disabled,
	onToggle,
	itemKey,
	inputId,
	value,
}: SimpleCheckboxProps) {
	return (
		<div className="checkbox-input">
			<input
				type="checkbox"
				id={inputId}
				value={itemKey}
				checked={checked}
				disabled={disabled}
				onChange={() => onToggle(itemKey, value)}
			/>
			<label htmlFor={inputId}>{value}</label>
		</div>
	);
}
